import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';

import { clearValues } from '../actions/clear-values';
import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';

export const clearValuesMenuItem: MenuItemBuilder = ({
  capabilities: { canClearContent },
  contentId,
  formatMessage,
  selectionsActions,
  selectedValuesCount,
}) => ({
  isEnabled: () => canClearContent,
  menuItem: {
    key: SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES,
    content: formatMessage(messages['value-actions.clear-cells'], {
      valuesCount: selectedValuesCount.toString(),
    }),
    onClick: () => clearValues(contentId),
    onMouseEnter: () => {
      selectionsActions.clearSelectionIntent();
    },
    shortcut: SHORTCUTS.CLEAR,
    elemBefore: <CrossCircleIcon label="" />,
  },
});
